module.exports = __webpack_public_path__ + "static/ApplicationRoot-79ae106cd74718048cb8ee241a980a98.png";